package com.xtream.ui.ui.widget

import androidx.compose.foundation.Image
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.VectorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.xtream.ui.ui.util.extensions.lightenColor
import androidx.compose.material3.Button as MaterialButton

@Composable
 fun Button(
    title: String,
    modifier: Modifier=Modifier,
    subtitle: String?=null,
    leadingIcon: Painter?=null,
    useIconTint: Boolean=false,
    fillParent: Boolean=false,
    iconSize: Dp=24.dp,
    startContent: @Composable (() -> Unit)? =null,
    endContent: @Composable (() -> Unit)?=null,
    onClick: () -> Unit
) {

    MaterialButton(
        onClick = onClick,
        modifier = modifier,
        enabled = true,
        colors = ButtonDefaults.buttonColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant.lightenColor(.05f),//.copy(alpha = .1f),
            // focusedContainerColor = MaterialTheme.colorScheme.onSurface,

            contentColor   = MaterialTheme.colorScheme.onSurface,
            // focusedContentColor =  MaterialTheme.colorScheme.background,






        ),
        content = {

            if (startContent!=null) {
                startContent.invoke()
                Spacer(modifier = Modifier.width(8.dp))
            }
            Column(
                modifier = Modifier.then(
                    if (fillParent || startContent != null)
                        Modifier.weight(1f)
                    else
                        Modifier
                )


            ) {
                Text(title, style = MaterialTheme.typography.titleSmall)
                if (!subtitle.isNullOrEmpty()) {
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(subtitle, style = MaterialTheme.typography.bodySmall)
                }
            }
            if (endContent!=null) {
                Spacer(modifier = Modifier.width(8.dp))

                endContent.invoke()
            }


        }
    )
}
@Composable
fun TvButton(
    title:String?=null,
    modifier: Modifier = Modifier,
    subtitle:String?=null,
    startContent: @Composable (() -> Unit)? = null,
    fillParent:Boolean = false,
    selected: Boolean=false,
    contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    iconSize: Dp =45.dp,
    endSeparator:( @Composable () -> Unit)? = null,

    trailingContent:( @Composable () -> Unit)? = null,

    onClick:()->Unit,
){
    TvBaseButton (
        title = title,
        modifier = modifier,
        fillParent = fillParent,
        subtitle = subtitle,
        selected=selected,
        contentPadding = contentPadding,
        endSeparator=endSeparator,
        startContent = startContent?.let { content ->
            {
                Box(modifier = Modifier.size(iconSize), contentAlignment = Alignment.Center) {
                    content.invoke()

                }

            }},

        endContent = trailingContent?.let { content ->
            {
                Box(modifier = Modifier.size(iconSize), contentAlignment = Alignment.Center) {
                    content.invoke()
                }
            }
        },
        onClick = onClick



    )
}
@Composable
fun TvButton(
    title:String,
    modifier: Modifier = Modifier,
    subtitle:String?=null,
    leadingIcon: Painter?=null,
    useIconTint:Boolean=true,
    fillParent:Boolean = false,
    selected: Boolean=false,
    contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    iconSize: Dp =45.dp,
    startContentScale: ContentScale= if ( leadingIcon is VectorPainter)
        ContentScale.Inside else
        ContentScale.Crop,
    trailingContent:( @Composable () -> Unit)? = null,

    onClick:()->Unit,
){


    TvBaseButton (
        title = title,
        modifier = modifier,
        fillParent = fillParent,
        subtitle = subtitle,
        selected=selected,
        contentPadding = contentPadding,
        startContent = leadingIcon?.let { icon ->
            {
                Image(
                    painter = icon,
                    contentDescription = title,
                    // 🚀 ContentScale.Crop behaves exactly like centerCrop in old Android XML
                    contentScale =
                        if ( icon is VectorPainter)
                        ContentScale.Inside else
                            ContentScale.Crop,

                    // 💡 This replaces the 'tint' parameter from the Icon component
                    colorFilter = if (useIconTint) ColorFilter.tint(LocalContentColor.current) else null,

                    modifier = Modifier
                        .size(iconSize)
                        .clip(RoundedCornerShape(8.dp))
                )
            }
        },
        endContent = trailingContent?.let { content ->
            {
                Box(modifier = Modifier.size(iconSize), contentAlignment = Alignment.Center) {
                    content.invoke()
                }
            }
        },
        onClick = onClick



        )
}




@Composable
fun TvBaseButton(
    title:String?,
    modifier: Modifier = Modifier,
    subtitle:String?=null,
    fillParent:Boolean = false,
    selected: Boolean=false,
interactionSource: MutableInteractionSource=remember { MutableInteractionSource() },
    contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    startContent:( @Composable () -> Unit)? = null,
    endSeparator:( @Composable () -> Unit)? = null,
    endContent:( @Composable () -> Unit)? = null,
    onClick:()->Unit,
){

    val isFocused by interactionSource.collectIsFocusedAsState()

// 2. Compute the background color dynamically based on selection and focus states
    val containerColor = if (isFocused) {
        MaterialTheme.colorScheme.onSurface
    } else {
        MaterialTheme.colorScheme.surfaceVariant.lightenColor(if (selected) 0.1f else 0f)
    }

// 3. Compute the content (Text/Icon) color dynamically
    val contentColor = if (isFocused) {
        MaterialTheme.colorScheme.background
    } else {
        MaterialTheme.colorScheme.onSurface
    }
    MaterialButton (
interactionSource=interactionSource,
            modifier = modifier
                .wrapContentHeight()

                .heightIn(min = 50.dp)
                .widthIn(min = 60.dp)
               /* .pointerInput(Unit) {
                awaitPointerEventScope {
                    while (true) {
                        val event = awaitPointerEvent()
                        val isTouch = event.changes.any { it.type == PointerType.Touch }
                        val isMouse = event.changes.any { it.type == PointerType.Mouse }

                        // Filter for Left Click or Touch
                        if (isTouch || (isMouse && event.buttons.isPrimaryPressed)) {

                            // Wait for the user to lift their finger/button
                            val upEvent = waitForUpOrCancellation()

                            if (upEvent != null) {
                                onClick()
                            }
                        }
                    }
                }
            }*/
                /*TODO.ifElse(!isDpadNavigation(),
                        Modifier.clickable(onClick = onClick)
                )*/
            //.clickable { onClick() }
            ,
        contentPadding = contentPadding,
        shape = RoundedCornerShape(12.dp),
            onClick = onClick,
            colors = ButtonDefaults.buttonColors(
                containerColor = containerColor,

                contentColor   = contentColor ,
              //  focusedContentColor =  MaterialTheme.colorScheme.background,





                ),

            /*scale = ButtonDefaults.scale(
                focusedScale = 1.1f,
                pressedScale = .9f
            ),
            glow = ButtonDefaults.glow(
                focusedGlow = Glow(
                    elevation = 9.dp,
                    elevationColor = MaterialTheme.colorScheme.background.copy(alpha = .5f)
                ),


                ) ,

            shape =ButtonDefaults.shape(
                shape = RoundedCornerShape(8.dp)),
            border = ButtonDefaults.border(
                border = Border.None,
                focusedBorder = Border(
                    border = BorderStroke(
                        width = 2.dp,
                        color = MaterialTheme.colorScheme.onBackground
                    ),
                )
            ),*/

            ){
            if (startContent!=null) {
                startContent.invoke()
                Spacer(modifier = Modifier.width(8.dp))
            }
            Column(
                modifier = Modifier.then(
                    if (fillParent)
                        Modifier.weight(1f)
                    else
                        Modifier
                )


            ) {
                if (!title.isNullOrEmpty())
                Text(title,            maxLines = 1,
                    style = MaterialTheme.typography.titleSmall)
                if (!subtitle.isNullOrEmpty()) {
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(subtitle,            maxLines = 1,
                        style = MaterialTheme.typography.bodySmall)
                }
            }
            if (endContent!=null) {

                if(endSeparator!=null){
                    Spacer(modifier = Modifier.width(4.dp))
                    endSeparator.invoke()
                }
                Spacer(modifier = Modifier.width(4.dp))



                endContent.invoke()
            }



        }

}


@Composable
fun XtreamComposeButton(text: String,onClick: () -> Unit){
    val interactionSource = remember { MutableInteractionSource() }
    val focusState by interactionSource.collectIsFocusedAsState()


    MaterialButton(
        onClick = onClick,
        interactionSource = interactionSource,
        /* modifier = Modifier.onFocusChanged {
             color=if (it.hasFocus) Color.White else Color.White.copy(alpha = 0.1f)
             contentsColor=if (it.hasFocus) Color.Black else Color.White
         },*/
        colors = ButtonDefaults.buttonColors(
            containerColor = if (focusState) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.secondary,
            contentColor = if (focusState) MaterialTheme.colorScheme.onSecondary else MaterialTheme.colorScheme.background


        )
    ) {
        Text(text = text)
    }
}